import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { trackPlantHeight } from '../../redux/reducers/team-slice';

const TrackPlantHeight = ({
  closeCallback,
  defaults: { defaultHeight },
  plantId,
  plantName,
}) => {
  const [formDate, setFormDate] = useState(null);
  const [formHeight, setFormHeight] = useState(defaultHeight);
  const dispatch = useDispatch();
  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={() => closeCallback()}></div>
      <div className="modal-content">
        <article className="message">
          <div className="message-header">
            <p>Höhe tracken für {plantName}</p>
            <button
              className="delete"
              aria-label="delete"
              onClick={() => closeCallback()}
            ></button>
          </div>
          <div className="message-body">
            <form
              onSubmit={(e) => {
                dispatch(
                  trackPlantHeight(
                    { plantId, height: formHeight, date: formDate },
                    closeCallback
                  )
                );
                e.preventDefault();
              }}
            >
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Höhe</label>
                </div>
                <div className="field-body field has-addons">
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      inputMode="numeric"
                      pattern="^\d+(,\d{1,2})?$"
                      placeholder="Pflanzenhöhe"
                      title="Gib die Pflanzengröße in cm an."
                      defaultValue={formHeight}
                      onChange={(e) => setFormHeight(e.target.value)}
                    />
                  </div>
                  <div className="control">
                    <a className="button is-static">cm</a>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label className="label">Datum & Uhrzeit</label>
                </div>
                <div className="field-body field">
                  <div className="control">
                    <input
                      className="input"
                      type="datetime-local"
                      onChange={(event) => setFormDate(event.target.value)}
                    />
                  </div>
                </div>
              </div>
              <button
                type="submit"
                className="mt-4 button is-fullwidth is-primary"
                disabled={!!!formDate}
              >
                fertig
              </button>
            </form>
          </div>
        </article>
      </div>
    </div>
  );
};

export default TrackPlantHeight;
